export default function() {

    return {

        setRequired(override, temp) {

            if(override == 'commercial') {
                temp.street = true;
                temp.company = true;
                temp.city = true;
                temp.state = true;
                temp.postalCode = true;
                temp.appointmentRequest = false;
                temp.preferredDate = false;
                temp.preferredTime = false;
                temp.customerType = false;
                temp.customerLocation = false;
                temp.productInterest = false;
            }

            return temp;
        },

        setShown(override, temp) {

            if(override == 'commercial') {
                temp.street = true;
                temp.company = true;
                temp.city = true;
                temp.state = true;
                temp.postalCode = true;
                temp.appointmentRequest = false;
                temp.preferredDate = false;
                temp.preferredTime = false;
                temp.customerType = false;
                temp.customerLocation = false;
                temp.productInterest = false;
            }

            return temp;
        },

        setValues(override) {

            const temp = []
            if(override == 'commercial') {
                temp['customerLocation'] = 'commercial';
            }

            return temp;
        },

    }
}